import { agents } from "@gromia/agents";
import * as s from "@gromia/components/theme/t.module.css";
import { Carousel } from "@gromia/components/ui/Carousel";
import { Text } from "@gromia/components/ui/Text";
import strings from "@gromia/strings/landingBecomeAgent";
import {
  getCmsAgentFullName,
  getCmsAgentPortraitUrl,
} from "@gromia/utils/models/agent";
import { useString } from "@gromia/utils/useString";
import cx from "classnames";
import * as React from "react";
import { Agent } from "./Agent";

type Props = {
  ctaButton: NonNullable<React.ReactNode>;
  className: string;
};

export function Agents(props: Props) {
  const { tx } = useString("landingBecomeAgent", strings);

  return (
    <section className={cx(props.className, s.space2, s.textCenter)}>
      <div className={cx(s.container)}>
        <Text tag="p" s="pill">
          {tx("testimonialPill")}
        </Text>
        <Text tag="h2" s="title">
          {tx("testimonialTitle")}
        </Text>
        <Text tag="p" s="titleSmall" short>
          {tx("testimonialText")}
        </Text>
        <Carousel>
          {agents.concat(agents).slice(0, 4).map(agent => (
            <Carousel.Pad>
              <Agent
                image={
                  <img
                    src={getCmsAgentPortraitUrl(agent)}
                    width={246}
                    height={246}
                    alt={getCmsAgentFullName(agent)}
                  />
                }
                line1={getCmsAgentFullName(agent)}
                line3={agent.city}
                line4={agent.rea}
              />
            </Carousel.Pad>
          ))}
        </Carousel>
        {props.ctaButton}
      </div>
    </section>
  );
}
